import store from '@/store';
import { p2pActions } from '@/store/p2p-slice';

import { handleNewP2Pkeys } from './createP2PKeys';
import { getUUID } from './getUuid';
import { sendP2PSocketData } from './p2pConnection';

export const sendCredentials = async (dataRec, source) => {
    const uuids = await getUUID();

    const { privateKeyStringified, publicKeyStringified } =
        await handleNewP2Pkeys(uuids[0].keypair);

    if (privateKeyStringified && publicKeyStringified) {
        store.dispatch(
            p2pActions.setP2PKeys({
                JSON_SERVER: publicKeyStringified,
                JSON_USER: privateKeyStringified,
            }),
        );
    }
    sendP2PSocketData({
        command: 'connect_peer',
        data: source,
    });

    setTimeout(() => {
        sendP2PSocketData({
            command: 'send_msg',
            data: {
                client_event: 'send_credentials',
                my_key: publicKeyStringified,
            },
        });
    }, 700);
};
